import  React, { useState, useEffect } from 'react';
import { projectStorage } from '../firebase/config';

const useStorage = file => {
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState(null);
  const [url, setUrl] = useState(null);

  useEffect(() => {
    // references
    const storageRef = projectStorage.ref(file.name);
    //const collectionRef = projectFirebase.collection("images");

    storageRef.put(file).on(
      'state_changed',
      snap => {
        let percentage = (snap.bytesTransferred / snap.totalBytes) * 100;
        setProgress(percentage);
      },
      err => {
        setError(err);
      },
      async () => {
        const url = await storageRef.getDownloadURL();
        //collectionRef.add({ url: url, createdAt: timestamp() });
        setUrl(url);
      }
    );
  }, [file]);

  return { url, error, progress };
};

export default useStorage;
